import { useHistory } from 'react-router-dom';
import * as service from 'services';
import * as hook from 'helpers/hooks';
import { errors } from 'helpers';
import { PrimaryButton, SecondaryButton } from 'components';
import { roleChangeValidation } from './validation/roleChangeValidation';

export const useGetRoleChangeButtons = (id, role) => {
	const history = useHistory();
	const { setLoader, setSnackbar, setSnackbarError } =
		hook.useCreateDispatches();
	const onPasswordConfirm = hook.usePasswordConfirm();
	const roleSelectRedirect = hook.useRoleSelectRedirect();

	const errorHandler =
		(error) =>
		({ response }) => {
			setSnackbarError({ response, ...error }, { log: true });
		};

	function CancelButton() {
		const onClick = () => history.goBack();
		return <SecondaryButton onClick={onClick}>Cancel</SecondaryButton>;
	}

	function SaveButton() {
		const handleClick = () => {
			const validate = roleChangeValidation(role);
			if (validate.isValid) {
				onPasswordConfirm(onClick);
			} else {
				setSnackbar({
					variant: 'error',
					message: validate.message,
				});
			}
		};

		const onClick = async () => {
			setLoader(true);
			service
				.updateUserRole(role, id)
				.then(async () => {
					await service.getAgencyUsers();
					await service.setChildrenList();
					roleSelectRedirect(role.role, id);
					setSnackbar({
						variant: 'success',
						message: 'Successfully changed role',
					});
				})
				.catch(errorHandler(errors.USER_SAVE('SW')))
				.finally(() => {
					setLoader(false);
				});
		};

		return (
			<PrimaryButton disabled={!role.role ? true : false} onClick={handleClick}>
				Save Changes
			</PrimaryButton>
		);
	}

	return [<CancelButton key='cancel' />, <SaveButton key='save' />];
};
